import { Box, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../Redux/store'
import { CartVariantImage, Item } from '../../../types/Cartlist'

function OrderSummary() {
    const { cartlist } = useSelector((state: RootState) => state.global)
    return (
        <Box className='border bg-white border-10 p-3'>
            <Box className='d-flex align-items-center justify-content-between mb-3'>
                <Typography variant='body2' className='fw-bold'>Order Summary</Typography>
                <Typography variant='body2' className='fw-bold text-main'>{cartlist?.items?.length} Items</Typography>
            </Box>
            <Box>
                {cartlist?.items?.map((item: Item, index: number) => (
                    <Box >
                        <Box className='d-flex align-items-center gap-2'>
                            <Box component={'img'} height={'50px'} width={'50px'} className='border-10 border' src={item?.variant?.images?.find((image: CartVariantImage) => image?.is_thumbnail)?.imageUrl || item?.variant?.images?.[0]?.imageUrl} alt={`Item ${index}`} />
                            <Box>
                                {/* <Typography className='fw-bold' variant='subtitle2'>{item?.variant?.name}</Typography> */}
                                <Tooltip title={item?.variant?.name || ''} arrow>
                                    <Typography
                                        className="fw-bold"
                                        variant="subtitle2"
                                        sx={{
                                            maxWidth: 300,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {item?.variant?.name}
                                    </Typography>
                                </Tooltip>
                                <Box className='d-flex align-items-center gap-3'>
                                    <Typography className='text-grey' variant='caption'>Size: {item?.variant?.size?.name}</Typography>
                                    <Typography className='text-grey' variant='caption'>Color: {item?.variant?.color?.name}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-grey' variant='caption'>Qty: {item?.quantity}</Typography>
                                    <Typography variant='body2'>
                                        {Number(item?.total).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "INR",
                                        })}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <hr className='my-2' />
                    </Box>
                ))}
            </Box>
            <Box className='mt-3'>
                <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                    <Typography className='text-grey' variant='body2'>Subtotal ({cartlist?.items?.length} Items)</Typography>
                    <Typography variant='body2'>
                        {Number(cartlist?.subtotal).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
                <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                    <Typography className='text-grey' variant='body2'>Tax({cartlist?.taxPercentage}%)</Typography>
                    <Typography variant='body2'>
                        {Number(cartlist?.taxAmount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
                <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                    <Typography className='text-grey' variant='body2'>Shipping Amount</Typography>
                    <Typography variant='body2'>
                        {Number(cartlist?.shippingAmount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
                <Box className='d-flex align-items-center justify-content-between gap-5'>
                    <Typography className='text-grey' variant='body2'>Total Discount</Typography>
                    <Typography className='text-green' variant='body2'>
                        {Number(cartlist?.totalDiscount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
                <hr />
                <Box className='d-flex align-items-center justify-content-between gap-5 mt-2'>
                    <Typography className='text-grey' variant='body1'>Total Amount</Typography>
                    <Typography className='text-dark-main fw-bold' variant='h6'>
                        {Number(cartlist?.grandTotal).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default OrderSummary
